import React from "react";
import { AlignmentAndTranscriptionModel, SubtitlesSource2 } from "@/schemas";
import InputLyrics from "./InputLyrics";
import { AlignModelSelect } from "./AlignModelSelect";
import { LyricsLangSelect } from "./LyricsLangSelect";

interface InputSubtitlesSource2Props {
  title?: string;
  value: SubtitlesSource2;
  onChange: (value: SubtitlesSource2) => void;
}

export default function InputVideoSource({
  title,
  value,
  onChange,
}: InputSubtitlesSource2Props) {
  function handleChangeModel(model: AlignmentAndTranscriptionModel) {
    if (model === "audioshake-transcription" || model === "whisper") {
      onChange({ ...value, type: "transcription", model });
    } else if (model === "audioshake-alignment" || model === "wav2vec2") {
      let lyrics = "";
      if (value.type === "alignment") {
        lyrics = value.lyrics;
      }
      onChange({
        ...value,
        type: "alignment",
        model,
        lyrics,
      });
    }
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-row items-center justify-between gap-2">
        <LyricsLangSelect
          withLabel
          withTopValue
          value={value.lang}
          onChange={(lang) => {
            onChange({ ...value, lang });
          }}
        />
        <AlignModelSelect
          value={value.model}
          onChange={(model) =>
            handleChangeModel(model as AlignmentAndTranscriptionModel)
          }
        />
      </div>

      {value.type === "alignment" && (
        <InputLyrics
          query={title}
          value={value.type === "alignment" ? value.lyrics || "" : ""}
          onChange={(lyrics) => {
            onChange({
              ...value,
              type: "alignment",
              model: "audioshake-alignment",
              lyrics: lyrics || "",
            });
          }}
        />
      )}
    </div>
  );
}
